<style>
	.bg873 {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 0.1s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar33{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.2vw;background-size:105% 105%;  }
.tabbar33 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar33 span.pos{  padding:0 1vw;}
.tabbar33 span.floder{ color:#666;}
 
 
.tabbar33 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;}

.rs_head{width:84vw;margin-left:7vw;margin-top:6vw;border:#3465ff solid 2px;height:4vw;border-top-left-radius:.5vw;border-top-right-radius:.5vw;
box-sizing:border-box; position:relative;z-index:9;}
.rs_head span{display:block;float:left;height:4vw;line-height:4vw;font-size:1.1vw;text-align:center;}
.rs_head span.sai{display:block;float:left;height:3.8vw;background:#3465ff;width:15vw;color:#fff;position:absolute;left:0;top:0;z-index:9;
box-sizing:border-box;font-weight: bold;}
.rs_head ul.xx{position:absolute;left:15vw;top:0;}
.rs_head ul.xx li{float:left;width:13.5vw;position:relative;margin:0;padding:0;overflow:hidden;height:4vw;cursor:pointer;}
.rs_head ul.xx li span.val{width:12vw;position:absolute;font-weight: bold;}
.rs_head ul.xx li img{position:absolute;top:1.2vw;width:1.5vw;right:1vw;}
.rs_head ul.xx li span.border{width:1px;height:2vw;border-right:#ddd soliid 1px;position:absolute;right:0;top:1vw;}
.quan{width:84vw;margin-left:7vw;background:#f9f9f9;height:4vw;}
.quan input{ width: 1.4vw;height:1.4vw;float:left;margin-left:1vw;margin-top:1.3vw;border-radius:.5vw;display:block;float:left;-webkit-border-radius:.5vw;}
.quan span.qx{display:block;float:left;line-height:4vw;font-size:1.1vw;padding-left:.5vw;}
.add_sj{width:8vw;height:2.4vw;border:#3465ff solid 1px;margin-top:.8vw;;float:right;margin-right:1vw;border-radius:.5vw;}
.add_sj img{display:block;float:left;width:1.4vw;margin-top:.5vw;margin-left:.5vw;}
.add_sj span{display:block;float:right;width:6.1vw;text-align:center;line-height:2.4vw;font-size:1vw;color:#3465ff;cursor:pointer;}
.add_sj:hover{background:#3465ff;}
.add_sj span:hover{color:#fff;}

.sj_list{width:84vw;margin-left:7vw;margin-top:1vw;height:8vw;border:#e5e5e5 solid 1px; }
.sj_left{width:40vw;height:100%; position:relative;float:left;}
.sj_left input{ width: 1.4vw;height:1.4vw;border-radius:.5vw;display:block;float:left;-webkit-border-radius:.5vw;position:absolute;left:1vw;top:1vw;}
.sj_left img{display:block;position:absolute;top:1vw;left:3vw;width:2vw;}
.sj_left_title{width:50vw;height:2vw;position:absolute;left:5vw;top:1vw;}
.sj_left_title span{display:block;float:left;line-height:2vw;}
.sj_left_title span.t1{font-size:1.2vw;color:#0F7A3E;text-decoration:underline;cursor:pointer;}
.sj_left_title span.t2{font-size:1vw;padding-left:.5vw;color:#999;}
.sj_left span.fl{position:absolute;display:block;top:3.5vw;left:5vw;font-size:1.2vw;color:#999;border:#ddd solid 1px;height:2vw;line-height:2vw;padding:0 .5vw;
    border-radius:.5vw;}
	
span.ff2{position:absolute;display:block;top:5.5vw;left:5vw;font-size:1.2vw;color:#999;height:2vw;line-height:2vw;padding:0 .5vw;}
	
.sj_middle{width:10vw;height:100%;border-right:#ddd solid 1px;float:right;box-sizing:border-box;border-left:#ddd solid 1px;}
.sj_middle span{display:block;height:2.65vw;line-height:2.65vw;text-align:left;border-bottom:#ddd solid 1px;width:8vw;padding:0 1vw;font-size:1.2vw;
 color:#333;}
 
.sj_right2{width:12vw;height:100%; float:right;box-sizing:border-box;}
.sj_right2 span{display:block;height:2.65vw;line-height:2.65vw;text-align:center;width:5vw;padding:0 1vw;font-size:1.2vw;
 color:#333; float: left;}
.sj_right2 span.mn2{color:#0F7A3E;}
.sj_right2 span.mn32{color:#f00; width: 5vw;float: left;text-align: center;}

.pagessss{margin:0 auto;padding:0;overflow:hidden;width:84vw;height:4vw; margin-top:2vw;} 
.pre{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;}
.pre img{width:2vw;margin-top:.25vw;margin-left:.2vw;}
 
.next{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;margin-left:1vw;}
.next img{width:2vw;margin-top:.25vw;margin-left:.25vw;}

.submits222{width:12vw;height:3.5vw;border-radius:.5vw;float:right;margin-right:.4vw;}
.submits222 button{background:#3268ff;outline:none;border:0;font-size:1.2vw;display:block;height:3.5vw;line-height:3.5vw;width:100%;color:#fff;border-radius:.5vw;}


.xiala{position:absolute;top:3.6vw;background:#fff;width:13.5vw;left:15vw;border:#ddd solid 1px;border-top:0;z-index:999999;box-sizing:border-box;
      max-height:30vw;  overflow-x: hidden;border-radius:.5vw;border-top-left-radius:0;border-top-right-radius:0;}
.xiala ul li{width:100%;height:3vw;line-height:3vw;text-align:center;border-bottom:#ddd solid 1px;box-sizing:border-box;font-size:1.1vw;
  cursor:pointer;}
.xiala ul li:last-child{border-bottom:0;}
.xiala ul li:hover{background:#d6e7f9;}
 
.xiala2{left:28.5vw;}
 
.xiala3{left:42vw;}
 
.xiala4{left:55.5vw;}
 
.xiala5{left:69vw;}

.progress2{width:35vw;height:30vw;background:#fff;position:fixed;top:10vw;z-index:999999;left:32.5vw;border-radius:.5vw;overflow:hidden;}
.progress_hd2{width:100%;height:4vw;font-size:1.2vw;font-weight:bold;border-bottom:#ddd solid 1px;color:#333;}
.progress_hd2 span.ap{display:block;width:40%;margin-left:30%;float:left;line-height:4vw;text-align:center;}
.progress_hd2 img.cha{display:block;width:2vw;height:2vw;float:right;margin-top:1vw;margin-top:1vw;cursor:pointer;}


 
.progress2 span.ma1{display:block;width:100%;text-align:center;line-height:2vw;font-size:1.1vw;color:#999;margin-top:1vw;}
.progress2 span.ma2{display:block;width:100%;text-align:center;line-height:2vw;font-size:1.4vw;color:#333;margin-top:1vw;font-weight:bold;}

.ma_box{width:70%;margin:0 auto;height:3.5vw;margin-top:3vw;border-radius:.5vw;text-indent:1vw;}
.ma_box input{width:65%;float:left;border:#ebebeb solid 1px;height:3.5vw;font-size:1.1vw;color:#333;border-radius:.5vw;}
.ma_box button{width:30%;float:right;height:3.5vw;background:#f5f5f5;border:0;outline:none;font-size:1.1vw;border:#ddd solid 1px;border-radius:.5vw;}
.ma_box input::placeholder{text-indent:1vw;color:#999;font-size:1.1vw;}

.progress2 button.submits3{width:70%;margin:0 auto;height:3.5vw;background:#3465ff;display:block;margin-top:3vw;border:0;outline:none;
font-size:1.1vw;color:#ffff;border-radius:.5vw;}
.progress2 button.submits5{width:70%;margin:0 auto;height:3.5vw;background:#3465ff;display:block;margin-top:1vw;border:0;outline:none;
font-size:1.1vw;color:#ffff;border-radius:.5vw;}
.biao_list{width:70%;max-height:10vw;border:#ddd solid 1px;margin-top:1vw;scroll:no;overflow-y:auto;border-top-left-radius:.5vw;border-top-right-radius:.5vw;}
.biao_list ul{margin:0 auto;width:95%;}
.biao_list ul li{width:100%;height:2vw;margin-top:.5vw;}
.biao_list ul li img{display:block;width:2vw;float:left;}
.biao_list ul li span{display:block;width:20vw;float:left;line-height:2vw;font-size:1.1vw;color:#0F7A3E;text-overflow:ellipsis;white-space:nowrap;}
.biao_tj{width:70%;margin:0 auto;border:#ddd solid 1px;height:3vw;border-top:0;border-bottom-left-radius:.5vw;border-bottom-right-radius:.5vw;}
.biao_tj span{display:block;line-height:3vw;float:left;text-align:center;font-size:1vw;}
.biao_tj span.bio1{width:49%;border-right:#ddd solid 1px;box-sizing:border-box; }
.biao_tj span.bio2{width:50%;}
.biao_tj b{color:#FA9C3B;font-weight:normal;}
.sj_fresh{width:10vw;height:100%; float:right;box-sizing:border-box;border-left:#ddd solid 1px;}
.sj_fresh img{display:block;margin:0 auto;width:2vw;margin-top:2.5vw;}
.sj_fresh span{display:block;width:100%;text-align:center;line-height:1vw;color:#3465ff;font-size:1vw;text-decoration:underline;cursor:pointer;}


.progress{width:35vw;height:30vw;background:#fff;position:fixed;top:10vw;z-index:999999;left:32.5vw;border-radius:.5vw;overflow:hidden;}
.progress_hd{width:100%;height:4vw;line-height:4vw;text-align:center;font-size:1.2vw;font-weight:bold;border-bottom:#ddd solid 1px;color:#333;}

.jd{width:190px;height:190px;margin-top:3vw; }
.msg3{width:100%;margin:0 auto;line-height:3vw;font-size:1.2vw;text-align:center;font-weight:bold;color:#333;margin-top:1vw;}
.fjd{width:10vw;height:13vw;margin:0 auto;margin-top:3vw; }
.fjd img{display:block;margin:0 auto;width:10vw;}
.fjd span{display:block;height:3vw;line-height:3vw;text-align:center;font-size:1.4vw;color:#32AD37;}
.msg4{width:20vw;height:4vw;margin:0 auto;}
.msg4 span{display:block;text-align:center;font-size:1.1vw;line-height:2vw;}
.msg4 span.ms41{color:#333;}
.import_btns{width:16vw;height:3vw;margin:0 auto;margin-top:0;}
.import_btns button{display:block;width:7.5vw;height:3vw;outline:none;border:0;border-radius:.5vw;font-size:1vw;}
.import_btns button.a3{margin:0 auto; background:#3465ff;color:#fff;margin-top:0; }


.mengban{width:100vw;height:100vh;position:fixed;top:0;z-index:999;
background:url(../../assets/images/yao_bg4.png) repeat;}


.progress222{width:35vw;height:20vw;background:#fff;position:fixed;top:10vw;z-index:999999;left:32.5vw;border-radius:.5vw;overflow:hidden;}
.progress_hd222{width:100%;height:4vw;font-size:1.2vw;font-weight:bold;border-bottom:#ddd solid 1px;color:#333;}
.progress_hd222 span.ap{display:block;width:40%;margin-left:30%;float:left;line-height:4vw;text-align:center;}
 

 
.progress222 p{display:block;width:90%;text-align:center;line-height:5vw;
font-size:1.2vw;margin:0 auto;
color:#333;margin-top:2vw;}
 
.confirm_boxes{width:100%;margin:0 auto;height:4vw; 
margin-top:2vw;}
.progress222 button.submits441{width:35%;margin:0 auto;height:3.5vw;background:#3465ff;display:block; 
border:0;outline:none;float:left;margin-left:5vw;
font-size:1.1vw;color:#ffff;border-radius:.5vw;}
.progress222 button.submits441:hover{background:#4C84FA;}
 
.progress222 button.submits442{width:35%;margin:0 auto;height:3.5vw;background:#ccc;display:block; 
border:0;outline:none;float:right;margin-right:5vw;
font-size:1.1vw;color:#ffff;border-radius:.5vw;}



.sj_r_box2{width: 12vw;height: 2.65vw;margin: 0;padding: 0;overflow: hidden;border-bottom:#ddd solid 1px;}
.sj_right2 span.vw2{ text-align: center;float: right;width: 5vw;float: left;padding: 0;cursor: pointer;color: #3465ff;border-left:#ccc solid 1px;
 box-sizing: border-box;}
.sj_right2 span.dc2{ text-align: center;float: right;width: 3vw;float: left;padding: 0;cursor: pointer;color: #3465ff;}
</style>
 
<template>
	<div class="bg873">
	        
         <transition name="draw">
		   <div class="mengban" v-show="del_show"></div>
		  </transition>
		 <transition name="draw">
		 <div class="progress222" v-show="del_show">
				  <div class="progress_hd222"><span class="ap">删除提示</span></div>
				  <p>是否确认删除"{{del_msg}}"</p>  
				  <div class="confirm_boxes">
					   <button class="submits441" @click="del_sure()">确定</button>
					   <button class="submits442" @click="del_cancel()">取消</button>
				  </div>
		 </div>
         </transition>

		
	     <u_center  ></u_center>
	     <div class="top_area">
		    <img @click="home()"  src="../../assets/images/home_icon.png">
			<div class="tabbar33">
			   <span class="pos">您的当前位置:</span>
			   <span class="floder">数据仓库</span>
			   
			</div>
		 </div>
		 <div class="rs_head">
		    <span class="sai">筛选数据表</span>
			<ul class="xx">
			   <li @click="xiala(1)"><span class="val">{{year}}</span><img src="../../assets/images/down.png"><span class="border"></span></li>
			   <li @click="xiala(2)"><span class="val">{{leibie}}</span><img src="../../assets/images/down.png"><span class="border"></span></li>
			   <li @click="xiala(3)"><span class="val">{{pici}}</span><img src="../../assets/images/down.png"><span class="border"></span></li>
			   <li @click="xiala(4)"><span class="val">{{dalei}}</span><img src="../../assets/images/down.png"><span class="border"></span></li>
			   <li @click="xiala(5)"><span class="val">{{area}}</span><img src="../../assets/images/down.png"></li>
			</ul>

              <transition name="draw">
				   <div class="xiala" v-show="xiala1">
					  <ul>
					      <li  @click="select_year('全部',0)">全部</li>
						 <li v-for="item in year_list" @click="select_year(item.year,item.id)">{{item.year}}</li>
					  </ul>
				   </div>
			   </transition>
               <transition name="draw">
				   <div class="xiala xiala2" v-show="xiala2">
					  <ul>
					      <li  @click="select_zhao('全部',0)">全部</li>
						 <li v-for="item in zhao_list" @click="select_zhao(item.name,item.id)">{{item.name}}</li>
					  </ul>
				   </div>
			   </transition>
               <transition name="draw">
				   <div class="xiala xiala3" v-show="xiala3">
					  <ul>
					     <li  @click="select_pi('全部',0)">全部</li>
						 <li v-for="item in pici_list" @click="select_pi(item.name,item.id)">{{item.name}}</li>
					  </ul>
				   </div>
			   </transition>
			    <transition name="draw">
				   <div class="xiala xiala4" v-show="xiala4">
					  <ul>
					     <li  @click="select_lei('全部',0)">全部</li>
						 <li v-for="item in lei_list" @click="select_lei(item.name,item.id)">{{item.name}}</li>
					  </ul>
				   </div>
			   </transition>
			   <transition name="draw">
				   <div class="xiala xiala5" v-show="xiala5">
					  <ul>
						 <li v-for="item in area_list" @click="select_area(item.region_name,item.id)">{{item.region_name}}</li>
					  </ul>
				   </div>
			   </transition>
			   
		 </div>
		 <div class="quan">
		    <input type="checkbox" v-model="all_check">
			<span class="qx">全选</span>
			<div class="add_sj" @mouseover="mouseOver_add()"  @mouseleave="mouseLeave_add()" @click="tj()"><img @click="add_data()"  :src="sms_add"><span>添加数据表</span></div>
		 </div> 
		 <div style="height:30vw;">
				 <div class="sj_list" v-for="item in list">
					 <div class="sj_left">
						<input type="checkbox" @click="check(item.id,0)" v-if="item.on==1" checked>
						<input type="checkbox" @click="check(item.id,1)" v-else>
						<img src="../../assets/images/excel.png">
						<div class="sj_left_title">
							<span class="t1"  >{{item.name}}</span>
							<span class="t2">{{item.date}}</span>
						</div>
						<span class="fl">{{item.year}}-{{item.zs_category}}-{{item.grade}}-{{item.category}}-{{item.area}}</span>
						<span class="ff2">导入时间：{{item.time|formatDate}}</span>
					 </div>
					 
					 <div class="sj_fresh" @click="del_temp(item.id,item.name)">
							<img src="../../assets/images/dustbin.png">
							<span >删除</span>
					 </div>
					   
					   
					   
					 <div class="sj_right2">
					 	<div class="sj_r_box2">
						  <span class="mn1">{{item.success+item.failed}}</span>
						</div>
						<div class="sj_r_box2">
						  <span class="mn2">{{item.success}}</span>
						</div>
						<div class="sj_r_box2" style="border-bottom: 0;">
						  <span class="mn32" style="border-bottom:0;">{{item.failed}}</span>
						   <span class="vw2" @click="view_results2(item.id)">查看</span>< 
						</div>
					 </div>
					 <div class="sj_middle">
						  <span class="m1">总数据条数</span>
						  <span class="m2">导入成功</span>
						  <span class="m3" style="border-bottom:0;">导入失败</span>
					 </div>
				 </div>
          </div>	 
         <div class="pagessss">
		    <div v-if="total_page>1">
				<div class="pre" @click="pre_page()"   v-if="page>1">
				   <img src="../../assets/images/pre2.png">
				</div>
				<div class="pre"   v-else>
				   <img src="../../assets/images/pre1.png">
				</div>
				
				<div class="next" @click="next_page()" v-if="page<total_page">
				   <img src="../../assets/images/next1.png">
				</div>
				<div class="next"  v-else>
				   <img src="../../assets/images/next2.png">
				</div>
			</div>
			<div class="submits222">
		        <button @click="nextstep()">发送短信</button>
		     </div>
		 </div>
	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
import Progress from "easy-circular-progress";
	export default {
	    components: {
		  u_center,
		  Progress
	    },
		data() {
			return {
				 list:[],
				 del_msg:"",
                 del_show:false,
                 del_id:"",				 
				 all_check:false,
				 year:"招生学年",
				 year_list:[],
				 xiala1:false,
				 xiala2:false,
				 xiala3:false,
				 xiala4:false,
				 xiala5:false,
				 leibie:"招生类型",
				 zhao_list:[{id:1,zhao:'统招'},{id:2,zhao:'单招'}],
				 pici:'招生批次',
				 pici_list:[{id:1,pi:'本科批'},{id:2,pi:'专科批'}],
				 dalei:"专业类别",
				 lei_list:[{id:1,lei:'普通类'},{id:2,lei:'财经类'},{id:3,lei:'艺术类'},{id:4,lei:'计算机类'}],
				 area:"招生地区",
				 area_list:[{id:0,area:'全国'},{id:2,area:'北京'},{id:3,area:'天津'},{id:4,area:'上海'},{id:5,area:'河北'},{id:6,area:'河南'}],
				 token:"",
				 year_id:'',
				 zs_category_id:'',
				 grade_id:'',
				 category_id:'',
				 area_id:'',
				 selected_items:0,
				 selected_files:0,
				 sms_add:"https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/add_sj.png",
				 page:1,
				 total_page:1,
			}
		},filters: {
				 formatDate: function(value) {
					var date = new Date();
					 date.setTime(value*1000);
					var month = date.getMonth() + 1;
					var hours = date.getHours();
					if (hours < 10)
						hours = "0" + hours;
					var minutes = date.getMinutes();
					if (minutes < 10)
						minutes = "0" + minutes;
					var time = date.getFullYear() + "-" + month + "-" + date.getDate() +" "+hours+":"+minutes   ;
					return time;
				}
			},
		mounted() {
		      let self=this;
		      var token= localStorage.getItem("token");
			  this.template = this.$utils.getUrlKey('template');
			  if(!token){
					 self.$router.push("/");  
			  }else{
			      self.token=token;
				  self.get_excel_list();
				  self.get_import_key();
 
			  }  
		},
		methods: {
		 del_temp(id,name){
		    this.del_show=true;
			this.del_id=id;
			this.del_msg=name;
		 },del_cancel(){
		     this.del_show=false;
		 },del_sure(){
		     let self=this;
		      axios.post(this.$api+'/message/del_template', {
					   token:self.token,
					   id:self.del_id
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					  self.$toast.center('删除成功');
					  self.del_show=false;
                      self.get_excel_list();
				      self.get_import_key();					  
				  }else{
				      self.$toast.center(data.msg);
				  }
		      }).catch(function (error) {
			         
		      });
		 },
		 mouseOver_add() {
			   this.sms_add="https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/add_sj2.png";
		   },mouseLeave_add() {
		       this.sms_add="https://anyunxin-sms.oss-cn-chengdu.aliyuncs.com/add_sj.png";
		   },
		    add_data(){
			  this.$router.push("/import_data");  
			},
			view_results2(id){
               this.$router.push("/view_results2?id="+id);   
			},
		    home(){
			  this.$router.push("/");  
			},
			tj(){
			   this.$router.push("/import_data2");  
			},  
		  nextstep(){
		        var count=0;
                let self=this;
                var new_list=[];				
				this.list.forEach(function(obj,index){
					new_list[index]=obj; 
					if(obj.on==1){
					   count++
					}
				});
				if(count==0){
				   self.$toast.center('请选择数据');
				}else{
				   var list=JSON.stringify(new_list);
				   
				   localStorage.setItem("file_list",list); 
				   this.$router.push("/select_template_store");  
				} 
		  },
		  get_import_key(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_import_key', {
					   token:self.token
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					  self.area_list=data.data.area;
                      self.lei_list=data.data.category_list;
                      self.pici_list=data.data.grade;	
                      self.zhao_list=data.data.zs_list;	
                      self.year_list=data.data.year_list;					  
				  } 
		      }).catch(function (error) {
			         
		      });
		   },
		   pre_page(){
		     if(this.page>1){
			    this.page=this.page-1;
				this.get_excel_list();
			 }
		   },next_page(){
		      if(this.page<this.total_page){
			    this.page=this.page+1;
				this.get_excel_list();
			  }
		   },
		   get_excel_list(){	        
		      let self=this;
		      axios.post(this.$api+'/message/get_excel_list', {
					   token:self.token,
					   year_id:self.year_id,
					   zs_category_id:self.zs_category_id,
					   grade_id:self.grade_id,
					   category_id:self.category_id,
					   area_id:self.area_id,
					   page:self.page
					   
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){                
					   self.list=data.data.list;	
                       self.total_page=data.data.total_page;						   
				  } 
		      }).catch(function (error) {
			         
		      });
		    },
		    check(id,val){
			    var new_list=[];
                let self=this;	
                    self.selected_files=0;	
                    self.selected_items=0;					
				this.list.forEach(function(obj,index){
					new_list[index]=obj;
					if( obj.id==id){
						new_list[index].on=val;
					} 
					if(new_list[index].on==1){
					  self.selected_files++;
					  self.selected_items=self.selected_items*1+new_list[index].success*1;
					}
				});
			    this.list=new_list;
			},all(val){
			    var new_list=[];
                    let self=this;	
                    self.selected_files=0;	
                    self.selected_items=0;						
				this.list.forEach(function(obj,index){
					new_list[index]=obj;
					new_list[index].on=val; 
					
					if(new_list[index].on==1){
					  self.selected_files++;
					  self.selected_items=self.selected_items*1+new_list[index].success*1;
					}
					
					
				});
			    this.list=new_list;
			},xiala(id){
			  if(id==1){
			     this.xiala1=!this.xiala1;this.xiala2=false;this.xiala3=false;this.xiala4=false;this.xiala5=false;
			  }else if(id==2){
			     this.xiala2=!this.xiala2;this.xiala1=false;this.xiala3=false;this.xiala4=false;this.xiala5=false;
			  }else if(id==3){
			     this.xiala3=!this.xiala3;this.xiala1=false;this.xiala2=false;this.xiala4=false;this.xiala5=false;
			  }else if(id==4){
			     this.xiala4=!this.xiala4;this.xiala1=false;this.xiala2=false;this.xiala3=false;this.xiala5=false;
			  }else if(id==5){
			     this.xiala5=!this.xiala5;this.xiala1=false;this.xiala2=false;this.xiala3=false;this.xiala4=false;
			  }
			},select_year(year,id){
			    if(id==0){
					this.year='招生学年';
				}else{
					this.year=year;
				}
			  this.xiala1=false;
			  this.year_id=id;
			  this.get_excel_list();
			},select_zhao(zhao,id){
				if(id==0){
					this.leibie='招生类型';
				}else{
					this.leibie=zhao;
				}
			  
			  this.xiala2=false;
			  this.zs_category_id=id;
			  this.get_excel_list();
			},select_pi(pi,id){
				if(id==0){
					this.pici='招生批次';
				}else{
					this.pici=pi;
				}
			  
			  this.xiala3=false;
			  this.grade_id=id;
			  this.get_excel_list();
			},select_lei(lei,id){
				if(id==0){
					this.dalei='专业类别';
				}else{
					this.dalei=lei;
				}
			  
			  this.xiala4=false;
			  this.category_id=id;
			  this.get_excel_list();
			},select_area(area,id){
				if(id==1){
					this.area='招生地区';
				}else{
					this.area=area;
				}
			  
			  this.xiala5=false;
			  this.area_id=id;
			  this.get_excel_list();
			}
		     
		},watch:{
			 all_check(){
			   if(this.all_check==true){
			     this.all(1)
			   }else{
			     this.all(0)
			   }
			 }
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/store/sms_list.vue